/* eslint-disable import/prefer-default-export */
import ApiClient from '../../loopback/apiClient';
import {
  SET_TRIAL_CATEGORY,
  TrialCategoryActionTypes,
  TrialCategory,
  AppThunk,
} from '../types';

const setTrialLabel = (payload: TrialCategory[]): TrialCategoryActionTypes => ({
  type: SET_TRIAL_CATEGORY,
  payload,
});

export const fetchTrialCategories = (): AppThunk => async (dispatch): Promise<void> => {
  const categories = await ApiClient.getTrialCategories();
  dispatch(setTrialLabel(categories));
};
